interface Props { active?: boolean }
export function MedsIcon({ active }: Props) {
  const sw = active ? 2.4 : 1.7;
  return (
    <svg width={26} height={26} viewBox="0 0 26 26" fill="none">
      <rect x={3} y={9} width={20} height={8} rx={4} stroke="currentColor" strokeWidth={sw} transform="rotate(-30 13 13)" />
      <path d="M9.5 8.2l5.2 9" stroke="currentColor" strokeWidth={sw} strokeLinecap="round" />
    </svg>
  );
}
